import { Brand } from './brand.type';

export const BRAND_HOSTS_MAP: { [host: string]: Brand } = {
  // mtiba
  'mtiba.com': 'mtiba',
  'mtiba.dev': 'mtiba',

  // aspire
  'healthaspire.com': 'aspire',
  'ae-test.carepay.dev': 'aspire',
  'ae-acc.carepay.dev': 'aspire',
  'ae-uat.carepay.dev': 'aspire',

  // aar
  'aarhealthcare.com': 'aar',
  'aar.co.ke': 'aar',

  // acs
  'acs-acc.carepay.dev': 'acs',
  'afiasolution.com': 'acs',
};
